import { Button, Snackbar } from "@mui/material";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { NotificationsContext } from "contexts/notificationContext";
import { forwardRef, useContext } from "react";

const Alert = forwardRef<HTMLDivElement, AlertProps>(function AlertCustom(
	props,
	ref,
) {
	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export function CustomAlert() {
	const { message, type, isOpen, closeNotification } =
		useContext(NotificationsContext);

	const handleClose = () => {
		closeNotification();
	};

	return (
		<Snackbar
			open={isOpen}
			autoHideDuration={6000}
			onClose={handleClose}
			sx={{ position: "absolute", maxWidth: "400px" }}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "right",
			}}
		>
			<Alert
				onClose={handleClose}
				severity={type}
				elevation={3}
				icon={false}
				variant="standard"
				action={
					<Button onClick={handleClose} color="inherit" size="medium">
						OK
					</Button>
				}
			>
				{message}
			</Alert>
		</Snackbar>
	);
}
